import React, { useContext, useEffect, useState } from 'react'
import { CustomSection } from 'styles/GlobalStyle'
import { AssessmentDefsCrud } from './hooks'
import { Type, WrapContent, WrapSelectAssessment, C, WrapAssessmentSection, Semester, WrapAssessment, WrapTitle, AssessmentName, WrapFooter, Method, WordsLength } from './Style'
import { CheckBox } from 'components/Form'
import { useSelector } from 'react-redux'
import { keyBy, map } from 'lodash'
import { AbilityContext } from 'components/Permissions/Can'
import { SvgIcon } from '@mui/material'
import { ReactComponent as CIcon } from 'assets/icons/C.svg';
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'

const Assessment = (props) => {
    const { selectedAssessmentDefs, setSelectedAssessmentDefs, selectAssessment, multiple = false, student, permission, title, footer, header, type_name, num_words, readability_score_name, name, visible_type, affiliation_name, layout_type: layoutTypeDef, author, id } = props
    const { user } = useSelector(state => state.user)
    const { selectedAssessmentDef, assessment } = useSelector(state => state.assessment)

    const ability = useContext(AbilityContext)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [balance, setBalance] = useState(user?.balance)

    const goAssessment = (id, header, footer, student) => {
        dispatch(actions.setAssessment({ ...assessment, reading_assessment_def_id: id }))
        navigate(`${app.assessmentDef}?assessmentDef=${id}${assessment?.id ? `&assessment=${assessment?.id}` : ""}`,
            {
                state: {
                    footer: footer,
                    header: header,
                    student: student,
                }
            }
        )
    }

    const updateAssessmentDefSelected = (assessment, selected, multiple) => {
        const { id } = assessment

        if (multiple) {
            const nSelectedAssessmentDefs = keyBy(selectedAssessmentDefs, "id")
            if (nSelectedAssessmentDefs[id])
                delete nSelectedAssessmentDefs[id]
            else nSelectedAssessmentDefs[id] = { ...assessment, selected: selected }
            const selectedAssessmentDefsToSave = map(nSelectedAssessmentDefs)
            setSelectedAssessmentDefs(selectedAssessmentDefsToSave)
        }
        // else {
        //     if (selectedAssessmentDef?.id === id)
        //         setSelectedAssessmentDefs(null)
        //     else setSelectedAssessmentDefs(assessment)
        // }
    }

    const keyBySelectedAssessmentDefs = keyBy(selectedAssessmentDefs, "id")

    const onSelectAssessment = () => {
        if (props?.onSelectAssessment)
            props?.onSelectAssessment(props)
        else goAssessment(id, header, footer, student)
    }

    useEffect(() => {
        setBalance(user.balance)
    }, [user?.balance])

    return (
        <WrapAssessmentSection>
            {
                selectAssessment && //selectAssessment flag is on
                <WrapSelectAssessment>
                    <CheckBox
                        disabled={
                            ability.cannot("manage", "super-user") && !balance
                        }
                        input={{
                            value: multiple ? keyBySelectedAssessmentDefs[id] : selectedAssessmentDef?.id === id,
                            onChange: (selected) => {
                                // הורדנו כרגע את הבדיקה של זכאות ליצירת מבדקים, זה פתרון מאד ספציפי ולא גמיש
                                // if (selected && balance === selectedAssessmentDefs.length)
                                //     alert("אין זכאות ליצרת מבדקים")
                                // else

                                updateAssessmentDefSelected({ id, name, layoutTypeDef, visible_type }, selected, multiple)
                            }
                        }} />
                </WrapSelectAssessment>}
            <CustomSection
                $bg
                height={200}
                width={300}
                $hover
                onClick={onSelectAssessment}
            >
                <WrapAssessment>
                    <WrapTitle>
                        <div className='type-and-c'>
                            <Type $bg={"thirdly3"}>
                                {id}
                            </Type>
                            <Type>
                                {type_name}
                            </Type>
                            {permission === 'PRIVATE' &&
                                <C>
                                    <SvgIcon fontSize="small" component={CIcon} inheritViewBox />
                                </C>}
                        </div>
                        <Semester>
                            {readability_score_name}
                        </Semester>
                    </WrapTitle>
                    <WrapContent>
                        <AssessmentName>{name}</AssessmentName>
                    </WrapContent>
                    <WrapFooter>
                        <Method>
                            {affiliation_name}{affiliation_name && author && ', '}{author}
                        </Method>
                        <WordsLength>{`${num_words} מילים`} </WordsLength>
                    </WrapFooter>
                </WrapAssessment>
            </CustomSection>
        </WrapAssessmentSection >
    )
}

export default Assessment